import HeroSection from "../components/HeroSection";

export default function Home() {
  return (
    <section id="home" className="scroll-mt-24 p-6">
      <HeroSection />
    </section>
  );
}
